export const IPO_TESTSSON_PATID = 3402321;
export const IPO_TESTSSON_PNR = '19650713-2758';
